import { spaceGQLFields } from './space.fields.js';
const BASIC_COLLECTION_FIELDS = {};
const ALL_COLLECTION_FIELDS = {
    space: 'basic',
};
export function collectionGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_COLLECTION_FIELDS;
    if (fields === 'all')
        fields = ALL_COLLECTION_FIELDS;
    return `
    id
    slug
    name
    description
    createdAt
    relativeUrl
    url
    ${fields.space
        ? `
      spaces(limit: 100) {
        totalCount
        edges {
          node {
            ${spaceGQLFields(fields.space)}
          }
        }
        nodes {
          ${spaceGQLFields(fields.space)}
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=collection.fields.js.map